import { CHAIN_ID, MAINNET_CHAIN_ID } from '../config';

const getBaseURL = (chainId: number) => {
  if (chainId === MAINNET_CHAIN_ID) {
    return 'https://opensea.io/';
  }
  return 'https://testnets.opensea.io/';
};

const BASE_URL = getBaseURL(CHAIN_ID);

export const buildOpenSeaAddressLink = (address: string): string => {
    const path = `item/ethereum/${address}`;
    return new URL(path, BASE_URL).toString();
  };


